import { ref, onMounted, onUnmounted, computed } from 'ui.vue3';
import { GoogleMapWrapper } from '../lib/GoogleMapWrapper';
import {PointsParser} from "../lib/PointsParser";
import ActivePointComponent from "./ActivePointComponent";
import MapFilterButtonComponent from "./MapFilterButtonComponent";
import MapFilterComponent from "./MapFilterComponent";
import {CATEGORIES_DATA, SHOP_TYPES_DATA} from "../lib/data";
import {getIsMobile} from "../lib/isMobile";
import VfnModal from "./VfnModal";
import MapFilterModalComponent from "./MapFilterModalComponent";
import {getCookie} from "../lib/getCookie";
import MapSearchComponent from "./MapSearchComponent";
import VfnSelect from "./VfnSelect";
import {fetchPlaceLocation} from "../lib/placesSearch";
import {getDistanceKm} from "../lib/distance";

export default {
  name: 'MapComponent',
  components: {
    MapSearchComponent,
    MapFilterModalComponent,
    MapFilterComponent,
    MapFilterButtonComponent,
    ActivePointComponent,
    VfnSelect,
    VfnModal
  },
  
  props: ['params'],
  setup(props) {
    
    // Мобильное разрешение
    const isMobile = getIsMobile()
    
    // Базовые параметры
    const params = props.params;
    
    
    
    // Фильтр
    const isActiveFilter = computed(() => {
      return activeFilterCountry.value.id !== allCountriesItem.id
        || activeFilterCity.value.id !== allCitiesItem.id
        || activeFilterCategory.value.length > 0
        || activeFilterShopType.value.length > 0
    })
    const filterVisible = ref(false);
    const onShowFilter = () => {
      onCloseActivePoint()
      filterVisible.value = true;
    }
    
    const onSetFilterByModal = (data) => {
      filterVisible.value = false;
      activeFilterCategory.value = data.categories;
      activeFilterShopType.value = data.shopTypes;
      activeFilterCountry.value = data.country;
      activeFilterCity.value = data.city;
      applyFilter();
    }
    
    const onClearFilter = () => {
      filterVisible.value = false;
      activeFilterCategory.value = categoriesList.map(el => el.code);
      activeFilterShopType.value = shopTypesList.map(el => el.code);
      activeFilterCountry.value = allCountriesItem;
      activeFilterCity.value = allCitiesItem;
      applyFilter();
    }
    
    // Категории
    const categoriesList = CATEGORIES_DATA.filter(el => el.useInFilter).map(el => ({
      name: el.name,
      code: el.code,
      img: el.filterImg,
    }));
    const activeFilterCategory = ref(categoriesList.map(el => el.code));
    
    // Типы магазинов
    const shopTypesList = SHOP_TYPES_DATA.filter(el => el.useInFilter).map(el => ({
      name: el.name,
      code: el.code,
      img: el.filterImg,
    }));
    const activeFilterShopType = ref(shopTypesList.map(el => el.code));
    
    // Страны
    const countryPlaceholder = 'All countries';
    const countryList = Object.entries(params?.countries ?? {})
      .map(([id, data]) => ({
          id: parseInt(id),
          ...data
        }))
      .sort((a, b) => a.name.localeCompare(b.name));
    const allCountriesItem = {
      code: '__all__',
      name: countryPlaceholder,
      id: 0,
    }
    countryList.unshift(allCountriesItem)
    
    const defaultCountryName = params?.current_country ?? '';
    const defaultCountry = countryList.find(country => country.name === defaultCountryName);
    const activeFilterCountry = ref(defaultCountry ? defaultCountry : allCountriesItem);
    const onSetActiveCountry = (country) => {
      activeFilterCountry.value = (!country || country === activeFilterCountry.value || country.id === allCountriesItem.id) ? allCountriesItem : country;
      activeFilterCity.value = allCitiesItem;
      applyFilter();
    }

    
    // Города
    const citiesPlaceholder = 'All cities';
    const citiesList = Object.entries(params?.cities ?? {})
      .map(([id, data]) => ({
        id: parseInt(id),
        ...data
      }))
      .sort((a, b) => a.name.localeCompare(b.name));
    const allCitiesItem = {
      code: '__all__',
      name: citiesPlaceholder,
      id: 0,
      country_id: 0,
    }
    citiesList.unshift(allCitiesItem)
    const visibleCitiesList = computed(() => {
      if (!activeFilterCountry.value || activeFilterCountry.value.id === allCountriesItem.id) {
        return citiesList;
      }
      return citiesList.filter(city => {
        if (city.id === allCitiesItem.id) {
          return true;
        }
        return city.country_id === activeFilterCountry.value.id
      });
    });
    const activeFilterCity = ref(allCitiesItem);
    const onSetActiveCity = (city) => {
      activeFilterCity.value = (!city || city === activeFilterCity.value || city.id === allCitiesItem.id) ? allCitiesItem : city;
      if (activeFilterCity.value && (!activeFilterCountry.value || activeFilterCountry.value.id === allCountriesItem.id)) {
        const countryToSet = countryList.find(country => country.id === activeFilterCity.value.country_id);
        if (countryToSet) {
          activeFilterCountry.value = countryToSet;
        }
      }
      applyFilter();
    }
    
    // Применить текущий фильтр
    const filterPoints = (points) => {
      return points.filter(point => {
        if (
          activeFilterCountry.value
          && activeFilterCountry.value.id !== allCountriesItem.id
          && point.raw?.country_id
          && point.raw.country_id !== activeFilterCountry.value.id
        ) {
          return false;
        }
        if (
          activeFilterCity.value
          && activeFilterCity.value.id !== allCitiesItem.id
          && point.raw?.city_id
          && point.raw.city_id !== activeFilterCity.value.id
        ) {
          return false;
        }
        let needShow = false;
        [
          ...activeFilterShopType.value,
          ...activeFilterCategory.value
        ].forEach(code => {
          if (point.raw[code]) {
            needShow = true;
          }
        });
        return needShow;
      })
    }
    const applyFilter = (updateZoom = true) => {
      activePointId.value = null;
      visiblePointsList.value = filterPoints(basePointsList);
      googleMapInstance.removeActivePoint(false);
      googleMapInstance.displayNewPoints(visiblePointsList.value, updateZoom);
    }
    
    // Точки на карте (Данные + колбэк по клику)
    const parser = new PointsParser('MapComponent');
    const basePointsList = parser.parse(params?.elems ?? []).map(el => {
      return {
        ...el,
        callback: (pointId) => {
          if (!googleMapInstance) {
            return;
          }
          
          // Если кликаем повторно на маркер - сбрасываем активность и масштабируем
          if (activePointId.value === pointId) {
            activePointId.value = null;
            googleMapInstance.removeActivePoint(false);
            return;
          }
          
          // Устанавливаем нужный маркер и масштабируем
          filterVisible.value = false;
          activePointId.value = pointId;
          googleMapInstance.setActivePointById(pointId, true);
        }
      }
    });
    
    // Видимые точки
    const visiblePointsList = ref(filterPoints(basePointsList));
    const activePointId = ref(null);
    const activePointData = computed(() => basePointsList.find(point => point.id === activePointId.value));
    
    // Поиск по магазинам и адресам
    const searchPlaceholder = isMobile ? 'Search' : 'Search by store or address';
    const selectSearchPlaceholder = 'Search country, city, index';
    const NEARBY_LIMIT = 3;
    const NEARBY_MAX_DISTANCE_KM = 150;

    const onSearchSelectPoint = (point) => {
      if (!point || !googleMapInstance) {
        return;
      }
      filterVisible.value = false;
      activePointId.value = point.id;
      googleMapInstance.setActivePointById(point.id, true);
    };

    const onFilterSearchSelectPoint = (point) => {
      filterVisible.value = false;
      onSearchSelectPoint(point);
    };

    const onFilterSearchSelectAddress = (item) => {
      filterVisible.value = false;
      onSearchSelectAddress(item);
    };

    const onSearchSelectAddress = async (item) => {
      const place = await fetchPlaceLocation(item);
      if (!place || !googleMapInstance) {
        return;
      }
      activePointId.value = null;
      googleMapInstance.removeActivePoint(false);

      const nearbyPoints = visiblePointsList.value
        .map(point => ({point, distance: getDistanceKm(place.location, point.coordinates)}))
        .filter(el => el.distance <= NEARBY_MAX_DISTANCE_KM)
        .sort((a, b) => a.distance - b.distance)
        .slice(0, NEARBY_LIMIT)
        .map(el => el.point);

      googleMapInstance.focusOnLocation(place.location, nearbyPoints);
    };

    // Закрытие активной по крестику
    const onCloseActivePoint = () => {
      activePointId.value = null;
      googleMapInstance.removeActivePoint(false);
    }
    
    
    // Карта
    const mapContainerRef = ref(null);
    let googleMapInstance = null;
    
    onMounted(async () => {
      if (!mapContainerRef.value) {
        console.error("GoogleMapWrapperComponent: DOM-элемент mapContainerRef не найден.");
        return;
      }
      // Инициализация Google Map (экземпляр класса)
      googleMapInstance = new GoogleMapWrapper(mapContainerRef.value, visiblePointsList.value, {
        activePointId: activePointId.value,
      });
      // Callback для выбора фильтра (All countries) при отдаление zoom
      googleMapInstance.setCallback('onSetAllCountries', () => {
        if (JSON.stringify(activeFilterCountry.value) !== JSON.stringify(allCountriesItem)) {
          activeFilterCountry.value = allCountriesItem;
          activeFilterCity.value = allCitiesItem;
          applyFilter(false);
        }
      })
    });
    
    onUnmounted(() => {
      if (googleMapInstance) {
        googleMapInstance.destroy();
        googleMapInstance = null;
      }
    });
    
    return {
      isMobile,
      mapContainerRef,
      activePointId,
      activePointData,
      onCloseActivePoint,
      countryList,
      activeFilterCountry,
      visibleCitiesList,
      activeFilterCity,
      onSetActiveCountry,
      onSetActiveCity,
      countryPlaceholder,
      citiesPlaceholder,
      isActiveFilter,
      filterVisible,
      onShowFilter,
      categoriesList,
      activeFilterCategory,
      shopTypesList,
      activeFilterShopType,
      allCountriesItem,
      allCitiesItem,
      citiesList,
      onSetFilterByModal,
      onClearFilter,
      visiblePointsList,
      searchPlaceholder,
      selectSearchPlaceholder,
      onSearchSelectPoint,
      onSearchSelectAddress,
      onFilterSearchSelectPoint,
      onFilterSearchSelectAddress
    };
  },
  template: `
    <div class="partners-map">
      <component :is="isMobile ? 'VfnModal' : 'MapFilterModalComponent'" v-model="filterVisible" v-bind="isMobile ? {contentsHeight: '80vh', modifiers: 'vfn-modal--partners-filter'} : {}">
         <MapFilterComponent v-if="filterVisible" :points="visiblePointsList" :searchPlaceholder="searchPlaceholder" @search-select-point="onFilterSearchSelectPoint" @search-select-address="onFilterSearchSelectAddress" :categoriesList="categoriesList" :activeFilterCategory="activeFilterCategory" :shopTypesList="shopTypesList" :activeFilterShopType="activeFilterShopType" :countryList="countryList" :activeFilterCountry="activeFilterCountry" :allCountriesItem="allCountriesItem" :citiesList="citiesList" :activeFilterCity="activeFilterCity" :allCitiesItem="allCitiesItem" :countryPlaceholder="countryPlaceholder" :citiesPlaceholder="citiesPlaceholder" @apply="onSetFilterByModal" @clear="onClearFilter" />
      </component>
      <div class="partners-map__top">
        <MapSearchComponent class="partners-map__top-item partners-map__top-search" :points="visiblePointsList" :placeholder="searchPlaceholder" @select-point="onSearchSelectPoint" @select-address="onSearchSelectAddress" />
        <MapFilterButtonComponent class="partners-map__top-item" :active="isActiveFilter" @click="onShowFilter" />
        <VfnSelect v-if="!isMobile" class="partners-map__top-item partners-map__top-select" :model-value="activeFilterCountry" @update:modelValue="onSetActiveCountry" :options="countryList" :placeholder="countryPlaceholder" :searchPlaceholder="selectSearchPlaceholder" />
        <VfnSelect v-if="!isMobile" class="partners-map__top-item partners-map__top-select" :model-value="activeFilterCity" @update:modelValue="onSetActiveCity" :options="visibleCitiesList" :placeholder="citiesPlaceholder" :searchPlaceholder="selectSearchPlaceholder" />
      </div>
      <div class="partners-map__map" ref="mapContainerRef"></div>
      <ActivePointComponent v-if="activePointData" :point="activePointData" :key="activePointData.id" @close="onCloseActivePoint" />
    </div>
  `,
};
